import { create } from 'zustand'

interface ErrorResponse {
  errors?: Record<string, string[]>
  message?: string
}

interface ErrorState {
  show: boolean
  error: ErrorResponse | null
  handleError: (error: ErrorResponse) => void
  closeError: () => void
}

const useHandleError = create<ErrorState>((set) => ({
  show: false,
  error: null,
  handleError: (error) => set({ error, show: true }),
  closeError: () => set({ show: false, error: null }),
}))

export default useHandleError
